module.exports = __webpack_public_path__ + "media/2.1305dcb4.mp3";